import {AxiosResponse} from 'axios';
import {AddressServiceRequest, EfeResponse, PersonalDataServiceRequest} from 'commons/models';
import EfeApi from 'services/api/Api';

async function getPersonalData(kycId: number): Promise<EfeResponse<PersonalDataServiceRequest>> {
    try {
        return await EfeApi.Clients.get<PersonalDataServiceRequest>(
            `/api/v1/clients/foreigners/personal/data/${kycId}`
        ).then((res: AxiosResponse<PersonalDataServiceRequest>) => {
            return Promise.resolve({
                data: res.data,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function updatePersonalData(
    request: PersonalDataServiceRequest
): Promise<EfeResponse<PersonalDataServiceRequest>> {
    try {
        return await EfeApi.Clients.put<PersonalDataServiceRequest>(
            '/api/v1/clients/foreigners/personal/data/person',
            request
        ).then((res: AxiosResponse<PersonalDataServiceRequest>) => {
            return Promise.resolve({
                data: res.data,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function saveAddress(
    request: AddressServiceRequest
): Promise<EfeResponse<AddressServiceRequest>> {
    try {
        return await EfeApi.Clients.put<AddressServiceRequest>(
            '/api/v1/clients/foreigners/personal/address',
            request
        ).then((res: AxiosResponse<AddressServiceRequest>) => {
            return Promise.resolve({
                data: res.data,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

export default {
    saveAddress,
    updatePersonalData,
    getPersonalData,
};
